import { getErrors } from "../../utils/Form";
import {
  formatCurrencyDisplay,
  MAX_TEXT_LENGTH,
  sanitizeCurrencyInput,
  sanitizeTextInput,
} from "../../utils/textSanitizer";
import "./FormInput.scss";
import { FormInputProps } from "./types";
import { IonItem, IonInput, IonLabel } from "@ionic/react";
import React from "react";
import { Controller } from "react-hook-form";

const FormInput: React.FC<FormInputProps> = ({ formMethods, fieldProps, validationProps }) => {
  const { control, errors } = formMethods;
  const { name, label, placeholder, format, typeNumber, currency, disableSanitizeValidation } =
    fieldProps;
  const { errorMessage, pattern, maxLength } = validationProps || {};
  const resolvedMaxLength = maxLength ?? {
    value: MAX_TEXT_LENGTH,
    message: `Maximo ${MAX_TEXT_LENGTH} caracteres`,
  };

  return (
    <Controller
      name={name}
      control={control}
      errors={errors}
      rules={{
        required: {
          value: validationProps ? true : false,
          message: errorMessage ?? "",
        },
        pattern: pattern ?? undefined,
        maxLength: resolvedMaxLength,
        validate: disableSanitizeValidation
          ? undefined
          : (value: string) =>
              value === sanitizeTextInput(value) || "El campo contiene caracteres no permitidos",
      }}
      render={({ onChange, name, value }) => (
        <div className="form-input">
          <IonItem lines="inset" className="ion-no-padding">
            <IonLabel position="floating">{label}</IonLabel>
            <IonInput
              onIonChange={(event) =>
                onChange(
                  currency
                    ? sanitizeCurrencyInput(event.detail.value ?? "")
                    : sanitizeTextInput(event.detail.value ?? "")
                )
              }
              name={name}
              value={
                currency
                  ? value
                    ? `$ ${formatCurrencyDisplay(String(value))}`
                    : ""
                  : format
                    ? format(value)
                    : value
              }
              type={!typeNumber ? "text" : "tel"}
              placeholder={placeholder ? placeholder : ""}
              maxlength={MAX_TEXT_LENGTH}
            />
          </IonItem>
          <div
            className="form-input__error-message"
            style={getErrors(errors, name) ? { opacity: 1 } : undefined}
          >
            {getErrors(errors, name)?.message}
          </div>
        </div>
      )}
    />
  );
};

export default FormInput;
